@if (form) {
  <rask-container-block [formGroup]="form">
    <div class="row mb-4">
      <rask-hot-doc
        [hotDoc]="hotDoc">
      </rask-hot-doc>
    </div>
    <div class="row">
      <rask-toggle-panel label="Radprisjusteringar" [defaultExpanded]="false"
        (onToggle)="onToggleRadpris($event)">
        <ng-container>
          <rask-hot-doc
            [hotDoc]="hotDocRadprisjusteringar">
          </rask-hot-doc>
          <div class="row">
            <rask-simple-selector
              formControlName="radprisLangdkorrektion" class="col-2" label="Längdkorrektion"
              [values]="basData.radprisLangdkorrektioner" aid="radprisLangdkorrektion">
            </rask-simple-selector>
            <rask-input-number class="col-1" label="Utgångsvärde" formControlName="radprisUtgangsvarde">
            </rask-input-number>
            <rask-button aid="calculate" class="col-1 mt-auto" color="primary" [disabled]="!viewModel.canEdit" (click)="applyRadpriser()">{{ applyRadpriserText() }}</rask-button>
          </div>
          <div class="row">
            <rask-button aid="copy" class="col-1" color="secondary" icon="fas fa-clipboard" (click)="copyRadpriser()">Kopiera radpriser</rask-button>
          </div>
        </ng-container>
      </rask-toggle-panel>
    </div>
    <br />
    @if (!viewModel.isMassEditering) {
      <div class="btn-group">
        <button type="button" aid="kapkriteria-forbjudet-att-kapa" [disabled]="!viewModel.canEdit" color="primary"
          class="btn kapkriteria-forbjudet-att-kapa" (click)="setKapkriterie('Förbjudet att kapa')">Förbjudet att
        kapa</button>
        <button type="button" aid="kapkriteria-endast-manuella-kap" [disabled]="!viewModel.canEdit" color="primary"
          class="btn kapkriteria-endast-manuella-kap" (click)="setKapkriterie('Endast manuella kap')">Endast manuella
        kap</button>
        <button type="button" aid="kapkriteria-endast-vardeaptering" [disabled]="!viewModel.canEdit" color="primary"
          class="btn kapkriteria-endast-vardeaptering" (click)="setKapkriterie('Endast värdeaptering')">Endast
        värdeaptering</button>
        <button type="button" aid="kapkriteria-inga-begransningar" [disabled]="!viewModel.canEdit" color="primary"
          class="btn kapkriteria-inga-begransningar" (click)="setKapkriterie('Inga begränsningar')">Inga
        begränsningar</button>
      </div>
    }
    <rask-button aid="calculate" color="primary" [disabled]="!viewModel.canEdit" (click)="openCalculate()">Påslag
    </rask-button>
    <rask-button aid="langddiameter" color="primary" [disabled]="!viewModel.canEdit"
    (click)="openLangdDiameterSetup()">Skapa längd/diameter</rask-button>
  </rask-container-block>
}
